export default __webpack_public_path__ + "static/media/CarouselActive.cd7d849e.svg";